<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    Icon,
    Button: PocketButton,
} = UIKit

const props = defineProps<{
    bannerTitle?: string
    showLink?: boolean
}>()

const emit = defineEmits<{
    close: []
}>()

const openLink = () => {
    window.open('https://help.educators.pocketprep.com/en/articles/10536988-exam-versions')
}
</script>

<template>
    <div class="content-version-banner">
        <Icon
            class="content-version-banner__close"
            type="close"
            @click="emit('close')"
        />
        <div class="content-version-banner__title">
            {{ props.bannerTitle }}
        </div>
        <slot class="content-version-banner__text">
        </slot>
        <div v-if="props.showLink" class="content-version-banner__link">
            <PocketButton
                class="content-version-banner__confirmation"
                type="tertiary"
                @click="openLink"
            >
                Learn More
                <Icon type="externalLink" class="content-version-banner__link-icon" />
            </PocketButton>
        </div>
    </div>
</template>

<style lang="scss" scoped>

.content-version-banner {
    position: relative;
    padding: 14px 12px 14px 13px;
    background-color: $barely-blue;
    border-radius: 5px;
    border: 1px solid rgba($brand-blue, 0.4);
    margin-bottom: 20px;
    font-size: 15px;

    &__close {
        position: absolute;
        top: 14px;
        right: 12px;
        color: $pewter;
        cursor: pointer;

        &:hover {
            color: $brand-black;
        }
    }

    &__title {
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 12px;
        line-height: 20px;
        width: 97%;
    }

    &__text {
        font-size: 14px;
        line-height: 19.12px;
        margin-bottom: 14px;
    }

    &__confirmation {
        font-weight: 600 !important;
        line-height: 19px !important;
        padding-left: 0 !important;
    }

    &__link {
        margin-top: 12px;
    }

    &__link-icon {
        margin-left: 4px;
    }
}
</style>
